// if (!Number(window.vctElements)) {
//   window.vctElements = 0;
// }
// window.vctElements++;
export default 'Number(window.vctElements)||(window.vctElements=0),window.vctElements++';
